import { Middleware } from "../middleware"

export default {



    getCountIndicators(origin,type,idCompany){
        return new Middleware()
        .method('GET')
        .append(`/odin/${origin}/${type}/count`)
        .params({
            idCompany
        })
        .build()
    },
    getTables(origin,idCompany){
        return new Middleware()
        .method('GET')
        .append(`/odin/${origin}/latest20`)
        .params({
            idCompany
        })
        .build()
    },


    getChartIncidents(idCompany) {
        return new Middleware()
            .method('GET')
            .append(`/odin/incidents/charts/severity_time_series`)
            .params({
                idCompany
            })
            .build()

    },

    getChartRequests(idCompany) {
        return new Middleware()
            .method('GET')
            .append(`/odin/requests/charts/criticality_time_series`)
            .params({
                idCompany
            })
            .build()

    },

 

  


}